import api from "@/service/api";
import variables from "@/service/variables";
export default class Service {

  getValues() {
    return api.get(variables.API_URL + "values");
  }
  /* getExpAWB() {
    return api.get(variables.API_URL + "GetExpAWB");
  }
  getExpAWBItem(iden) {
    return api.get(variables.API_URL + "GetExpAWBItem?Iden="+iden);
  } */
  updateImpAWBItem(item) {
    return api.uploadmultipart(variables.API_URL + "UpdateImpAWBItem",item);
  }
  
  downloadImpSendReport(item) {
    return api.download(variables.API_URL + "DownloadSendReport",item);
  }
  updateSendReport(item) {
    return api.post(variables.API_URL + "UpdateSendReport",item);
  }
  
  updateExpGoodsStatus(item) {
    return api.post(variables.API_URL + "UpdateExpGoodsStatus",item);
  }
  

   getExpAWB(params) {
    return api.post(variables.API_URL + "GetExpAWB",params);
  }
  getExpAWBItem(iden) {
    return api.get(variables.API_URL + "GetExpAWBItem?Iden="+iden);
  } 

  getImpAWB(params) {
    return api.post(variables.API_URL + "GetImpAWB",params);
  }
  getImpAWBItem(iden) {
    return api.get(variables.API_URL + "GetImpAWBItem?Iden="+iden);
  }

  getAgentAreaCodeAudio() {
    return api.get(variables.API_URL + "GetAgentAreaCodeAudio");
  }
  updateAgentAreaCodeAudio(items) {
    return api.post(variables.API_URL + "UpdateAgentAreaCodeAudio",items);
  }
  updateStatusClear(clearCode) {
    return api.get(variables.API_URL + "UpdateStatusClear?ClearCode="+clearCode);
  }
  downloadStatusClear(date1,date2) {
    return api.download(variables.API_URL + "DownloadStatusClear?Date1="+date1+"&Date2="+date2);
  }
  
   


  /////////////////////////////////////////////////////////////////////////
  login(username, password) {
    return api.post(variables.API_URL + "Token", { Username: username, Password: password });
  }
}
